import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "mortModal",
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Барьцаа хөрөнгө нэмэх", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = {
  class: "modal-body",
  style: {"padding":"5px 40px 5px 40px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"red"} }, "ҮНЭЛГЭЭНИЙ ТАЛААРХ МЭДЭЭЛЭЛ", -1)
const _hoisted_11 = { style: {"float":"left"} }
const _hoisted_12 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_13 = { class: "el-input el-input--mini" }
const _hoisted_14 = { class: "el-input el-input--mini" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"red"} }, "БАРЬЦАА ХӨРӨНГИЙН ӨМЧЛӨГЧИЙН ТУХАЙ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"red"} }, " БАРЬЦАА ХӨРӨНГИЙН БҮРТГЭЛИЙН ТАЛААРХ МЭДЭЭЛЭЛ ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", { style: {"color":"red"} }, "ШИЛЖҮҮЛСЭН МЭДЭЭЛЭЛ", -1)
const _hoisted_21 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_22 = ["data-kt-indicator"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хадгалах ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            model: this.mortData,
            rules: this.mortDataRule,
            ref: "formRef",
            size: "mini",
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Төрөл" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.mortData.type,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mortData.type) = $event)),
                            style: {"width":"100%"},
                            placeholder: "--Сонгох--"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "0",
                                label: "Үл хөдлөх хөрөнгө"
                              }),
                              _createVNode(_component_el_option, {
                                value: "1",
                                label: "Үл хөдлөхөөс бусад"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Хөрөнгийн үл давхардах дугаар",
                        prop: "uniquenumber"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: this.mortData.uniquenumber,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.mortData.uniquenumber) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Хөрөнгийн үндсэн төрөл",
                        prop: "mrtType1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.mortData.mrtType1,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mortData.mrtType1) = $event)),
                            style: {"width":"100%"},
                            placeholder: "--Сонгох--",
                            filterable: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.mrtType1, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.mrtcode,
                                  label: item.mrtname,
                                  value: item.mrtcode
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      (_ctx.mortData.mrtType1)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Хөрөнгийн дэд төрөл",
                            prop: "mrtType2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.mortData.mrtType2,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mortData.mrtType2) = $event)),
                                style: {"width":"100%"},
                                filterable: "",
                                placeholder: "--Сонгох--"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMrtType2, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.submrtcode,
                                      label: item.submrtname,
                                      value: item.submrtcode
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Байршлын зип код",
                        prop: "zipcode"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.zipcode,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mortData.zipcode) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 15 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Хөрөнгийн байршлын хаяг",
                        prop: "address"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.mortData.address,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mortData.address) = $event)),
                            autosize: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Тайлбар",
                        prop: "desc"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.desc,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mortData.desc) = $event)),
                            type: "textarea",
                            autosize: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Үнэлгээ хийсэн огноо",
                        prop: "dateofvaluation"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.mortData.dateofvaluation,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.mortData.dateofvaluation) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Валютын код",
                        prop: "currency"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.mortData.currency,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mortData.currency) = $event)),
                            placeholder: "--Сонгох--",
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.currencies, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.currencycode,
                                  label: item.monname,
                                  value: item.currencycode
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.monname), 1),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.engname), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 7 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Шаардлагыг хангаж болох дээд хязгаар",
                        prop: "limit"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_VueNumberFormat, {
                              class: "el-input__inner",
                              value: _ctx.mortData.limit,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mortData.limit) = $event))
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Барьцаа хөрөнгийн үнэлгээ",
                        prop: "mrtvalue"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_VueNumberFormat, {
                              class: "el-input__inner",
                              value: _ctx.mortData.mrtvalue,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mortData.mrtvalue) = $event))
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_15,
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Хэлбэр" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            placeholder: "--Сонгох--",
                            modelValue: _ctx.mortData.selectCitizenOrg,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mortData.selectCitizenOrg) = $event)),
                            style: {"width":"100%"},
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (
                      this.propstateregisterno =
                        this.propstateregisterno === '' ? 'stateregisterno' : ''
                    ))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Иргэн",
                                value: "0"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Байгууллага",
                                value: "1"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      (_ctx.mortData.selectCitizenOrg === '0')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Овог",
                            prop: "surname"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.mortData.surname,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mortData.surname) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "Улсын бүртгэлийн дугаар",
                            prop: "stateregisterno"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.mortData.stateregisterno,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.mortData.stateregisterno) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Нэр",
                        prop: "givenname"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.givenname,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mortData.givenname) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: 
                    _ctx.mortData.selectCitizenOrg === '0'
                      ? 'Монгол улсын иргэн эсэх'
                      : 'Монгол улсад бүртгэлтэй эсэх'
                  
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.mortData.selectSocial,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mortData.selectSocial) = $event)),
                            placeholder: "--Сонгох--",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Тийм",
                                value: "1"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Үгүй",
                                value: "0"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Регистрийн дугаар",
                        prop: "registerno"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.registerno,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mortData.registerno) = $event)),
                            placeholder: 
                      _ctx.mortData.selectCitizenOrg === '0' &&
                      _ctx.mortData.selectSocial === '1'
                        ? 'AB________'
                        : ''
                    
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 })
                ]),
                _: 1
              }),
              _hoisted_17,
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Бүртгүүлсэн байгууллага" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            placeholder: "--Сонгох--",
                            modelValue: _ctx.mortData.authImmovable,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mortData.authImmovable) = $event)),
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.authImmovable, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.itemid,
                                  label: item.name1,
                                  value: item.itemid
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 15 }, {
                    default: _withCtx(() => [
                      (_ctx.mortData.authImmovable === '01')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Барьцаалсан тухай ЭХЭУБГазарт бүртгүүлж баталгаажуулсан огноо",
                            prop: "mrtconfirmeddate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.mortData.mrtconfirmeddate,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.mortData.mrtconfirmeddate) = $event)),
                                placeholder: "YYYY-DD-MM"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Улсын бүртгэлийн дугаар",
                        prop: "mrtstateregisterno"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.mrtstateregisterno,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.mortData.mrtstateregisterno) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Гэрчилгээний дугаар",
                        prop: "mrtcertificateno"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.mortData.mrtcertificateno,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mortData.mrtcertificateno) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Бүртгэгдсэн огноо",
                        prop: "mrtregistereddate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.mortData.mrtregistereddate,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.mortData.mrtregistereddate) = $event)),
                            placeholder: "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_19,
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "Шилжүүлсэн үндэслэл" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.mortData.transferreason,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.mortData.transferreason) = $event)),
                            style: {"width":"100%"},
                            placeholder: "--Сонгох--"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "--Сонгох--",
                                value: ""
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.transferReason, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.itemid,
                                  label: item.name1,
                                  value: item.itemid
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      (!_ctx.mortData.transferreason)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Шүүхийн шийдвэр гарсан огноо"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.mortData.courtorderdate,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.mortData.courtorderdate) = $event)),
                                placeholder: "YYYY-MM-DD"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "Шүүхийн шийдвэр гарсан огноо",
                            prop: "courtorderdate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.mortData.courtorderdate,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.mortData.courtorderdate) = $event)),
                                placeholder: "YYYY-MM-DD"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      (!_ctx.mortData.transferreason)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "Шүүхийн шийдвэрийн дугаар"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.mortData.courtorderno,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.mortData.courtorderno) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "Шүүхийн шийдвэрийн дугаар",
                            prop: "courtorderno"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.mortData.courtorderno,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.mortData.courtorderno) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_el_row, {
            type: "flex",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                hidden: "",
                size: "mini",
                ref: "submitRef",
                class: "col-lg-3",
                onClick: _ctx.saveFormData
              }, null, 8, ["onClick"]),
              _createElementVNode("button", {
                class: "el-button el-button--success el-button--mini is-plain col-lg-3",
                plain: "",
                size: "mini",
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args))),
                "data-kt-indicator": this.loadButton
              }, _hoisted_25, 8, _hoisted_22),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "mini",
                class: "col-lg-3",
                id: "modalBackButtonMortModal",
                onClick: _ctx.clearField,
                "data-bs-dismiss": "modal"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}